import Modal from '@atoms/Modal/Modal';
import Video from '@atoms/Video/Video';
import VideoProviderEnum from '@models/enums/VideoProviderEnum';
import ExternalVideo from '@molecules/ExternalVideo/ExternalVideo';
import { useState } from 'react';

interface Props {
  readonly dataTestId?: string;
  readonly videoTitle?: string;
  readonly videoProvider?: VideoProviderEnum;
  readonly videoId?: string;
  readonly videoUrl?: string;
  readonly isOpen: boolean;
  readonly onOpenChange: (isOpen: boolean) => void;
  readonly onCloseCallback?: () => void;
  readonly shouldCloseOnClickOutsideContent?: boolean;
  readonly transparent?: boolean;
}

const VideoModal = ({
  videoTitle,
  videoProvider,
  videoId,
  isOpen,
  onOpenChange,
  onCloseCallback,
  shouldCloseOnClickOutsideContent = true,
  transparent = true,
  videoUrl,
  dataTestId,
}: Props) => {
  const [isPlaying, setIsPlaying] = useState(true);

  return (
    <Modal
      setIsOpen={onOpenChange}
      onCloseCallback={onCloseCallback}
      isOpen={isOpen}
      modalClasses="flex flex-col justify-center items-center"
      contentClasses="w-full max-h-[90vh] py-4"
      transparent={transparent}
      shouldCloseOnClickOutsideContent={shouldCloseOnClickOutsideContent}
      data-testid={dataTestId}
    >
      {videoId && videoProvider && (
        <ExternalVideo
          title={videoTitle}
          videoProvider={videoProvider}
          videoId={videoId}
          autoPlay
          classes="max-h-full w-auto m-auto"
        />
      )}

      {videoUrl && (
        <Video
          classes="max-h-full w-auto m-auto"
          title={videoTitle}
          videoSource={videoUrl}
          videoAttributes={{
            playsinline: true,
            muted: false,
            playing: true,
            loop: true,
          }}
          controls
          isPlaying={isPlaying}
          setIsPlaying={setIsPlaying}
        />
      )}
    </Modal>
  );
};

export default VideoModal;
